/**
 * 日ごとの取込状況(2026-10-12 発注者指示。CSVインポートの BlueBean タブに出す)。
 * daily_summary.sources(OPレポート・対応履歴の取込記録)と staff の合計から、日ごとに
 * 「OPレポートが入っているか」「対応履歴が入っているか」を判定する。画面では計算しない。
 */
import type { DailySummary, DateStr } from '@core/lib/types';

/** both=両方あり / op_only=OPレポートだけ(取得が0になる) / activity_only=対応履歴だけ(時間が0になる) / none=どちらも無い / other=取込記録が無いのに数字がある(サンプル・手入力など) */
export type ImportStatusKind = 'both' | 'op_only' | 'activity_only' | 'none' | 'other';

export type ImportStatusRow = {
  date: DateStr;
  status: ImportStatusKind;
  op: { fileName: string; rowCount: number } | null;
  activity: { fileName: string; codes: string[]; appointments: number }[];
  /** 日次集計の行の合計 */
  appointments: number;
  workedHours: number;
  staffRows: number;
};

const pad = (n: number) => String(n).padStart(2, '0');

/** 月の1日〜末日(今日より先は出さない)の取込状況 */
export function importStatusRows(month: string, summaries: Pick<DailySummary, 'date' | 'staff' | 'sources'>[], today: DateStr): ImportStatusRow[] {
  const [y, m] = month.split('-').map(Number) as [number, number];
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  const byDate = new Map(summaries.map((s) => [s.date, s]));
  const out: ImportStatusRow[] = [];
  for (let d = 1; d <= last; d++) {
    const date = `${month}-${pad(d)}`;
    if (date > today) break;
    const s = byDate.get(date);
    const op = s?.sources?.op_report ? { fileName: s.sources.op_report.file_name, rowCount: s.sources.op_report.row_count } : null;
    const activity = (s?.sources?.activity ?? []).map((a) => ({ fileName: a.file_name, codes: a.business_codes, appointments: a.appointments }));
    const staff = s?.staff ?? [];
    const appointments = staff.reduce((t, r) => t + (r.appointments ?? 0), 0);
    const workedHours = Math.round(staff.reduce((t, r) => t + (r.worked_hours ?? 0), 0) * 100) / 100;
    const status: ImportStatusKind = op && activity.length ? 'both' : op ? 'op_only' : activity.length ? 'activity_only' : staff.length ? 'other' : 'none';
    out.push({ date, status, op, activity, appointments, workedHours, staffRows: staff.length });
  }
  return out;
}
